import React from 'react';

const Services = () => (
  <div className="pt-10 md:pt-10 pb-14 bg-white">
    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="lg:text-center">
        <h3 className="text-3xl mb-4 md:text-5xl leading-20 font-extrabold tracking-tight text-gray-700">
          Let Us Supercharge Your Business
        </h3>
        <p className="mt-4 max-w-2xl text-xl leading-7 text-gray-500 lg:mx-auto">
          Pull back the curtains on digital marketing. We're here to provide expert advice to fuel
          your marketing strategy.
        </p>
      </div>
    </div>

    <div className="lg:mt-14 max-w-screen-xl mx-auto">
      <ul className="border-none md:grid md:grid-cols-2 md:col-gap-8 md:row-gap-10">
        <li className="list-none -mb-8">
          <div className="flex">
            <div className="pl-4 md:pl-0 flex-shrink-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-yellow-300 text-white">
                <svg className="h-8 w-8" fill="white" viewBox="0 0 24 24">
                  <path d="M14 19h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zm0 2h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zm.25 2h-4.5l1.188.782c.154.138.38.218.615.218h.895c.234 0 .461-.08.615-.218l1.187-.782zm3.75-13.799c0 3.569-3.214 5.983-3.214 8.799h-1.989c-.003-1.858.87-3.389 1.721-4.867.761-1.325 1.482-2.577 1.482-3.932 0-2.592-2.075-3.772-4.003-3.772-1.925 0-3.997 1.18-3.997 3.772 0 1.355.721 2.607 1.482 3.932.851 1.478 1.725 3.009 1.72 4.867h-1.988c0-2.816-3.214-5.23-3.214-8.799 0-3.723 2.998-5.772 5.997-5.772 3.001 0 6.003 2.051 6.003 5.772zm4-.691v1.372h-2.538c.02-.223.038-.448.038-.681 0-.237-.017-.464-.035-.69h2.535zm-10.648-6.553v-1.957h1.371v1.964c-.242-.022-.484-.035-.726-.035-.215 0-.43.01-.645.028zm-3.743 1.294l-1.04-1.94 1.208-.648 1.037 1.933c-.418.181-.822.401-1.205.655zm10.586 1.735l1.942-1.394.799 1.115-2.054 1.473c-.191-.43-.423-.827-.687-1.194zm-3.01-2.389l1.038-1.934 1.208.648-1.041 1.941c-.382-.254-.786-.473-1.205-.655zm-10.068 3.583l-2.054-1.472.799-1.115 1.942 1.393c-.264.366-.495.763-.687 1.194zm13.707 6.223l2.354.954-.514 1.271-2.425-.982c.21-.397.408-.812.585-1.243zm-13.108 1.155l-2.356 1.06-.562-1.251 2.34-1.052c.173.433.371.845.578 1.243zm-1.178-3.676h-2.538v-1.372h2.535c-.018.226-.035.454-.035.691 0 .233.018.458.038.681z" />
                </svg>
              </div>
            </div>
            <div className="ml-4 pr-8 mb-10 md:mb-0 md:pr-0">
              <h5 className="text-lg leading-6 font-medium text-gray-900">Branding Strategy</h5>
              <p className="mt-2 text-base leading-6 text-gray-500">
                If you're looking to revitalize your brand online, we can help.
              </p>
            </div>
          </div>
        </li>
        <li className="list-none -mb-8">
          <div className="flex">
            <div className="pl-4 md:pl-0 flex-shrink-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-teal-400 text-white">
                <svg className="h-8 w-8" fill="white" viewBox="0 0 24 24">
                  <path d="M20.699 11.069c1.947 1.015 3.3 2.81 3.3 4.977 0 1.204-.433 2.387-1.202 3.304-.032 1.075.601 2.618 1.171 3.741-1.529-.277-3.702-.886-4.686-1.49-.833.202-1.631.295-2.385.295-2.919 0-5.185-1.398-6.278-3.271 6.427-.207 9.818-4.482 10.08-7.556zm-10.798-10.07c-5.282 0-10 3.522-10 8.34 0 1.708.615 3.385 1.705 4.687.046 1.525-.851 3.713-1.66 5.307 2.168-.392 5.251-1.257 6.648-2.114 7.696 1.873 13.307-2.837 13.307-7.88 0-4.844-4.751-8.34-10-8.34zm3.048 10.74c-.212.071-.441-.044-.511-.256 0 0-1.496-.501-3.272.088l1.166 1.814c.121.179.037.422-.164.49l-.794.263-.167.028c-.149 0-.294-.064-.396-.179l-1.604-1.77c-.873.276-1.862-.042-2.192-.865-.076-.188-.114-.389-.114-.592 0-.585.327-1.183 1.038-1.533 3.559-1.747 4.128-3.696 4.128-3.696-.086-.262.11-.532.382-.532.169 0 .327.108.383.277l2.371 5.952c.071.212-.044.441-.254.511zm1.687-2.043l-.614-.261c.267-.634.293-1.371.014-2.058-.279-.688-.808-1.199-1.441-1.466l.26-.615c1.265.535 2.046 1.771 2.046 3.091 0 .454-.092.898-.265 1.309zm-1.063-.451l-.599-.254c.154-.365.169-.789.008-1.185-.16-.396-.466-.69-.83-.843l.253-.601c.518.219.952.635 1.179 1.198.229.564.207 1.165-.011 1.685z" />
                </svg>
              </div>
            </div>
            <div className="ml-4 pr-8 mb-10 md:mb-0 md:pr-0">
              <h5 className="text-lg leading-6 font-medium text-gray-900">
                SEM & Digital Marketing
              </h5>
              <p className="mt-2 text-base leading-6 text-gray-500">
                We’ll evaluate how to best meet your marketing needs in an online world and get to
                work making that happen.
              </p>
            </div>
          </div>
        </li>
        <li className="list-none -mb-16">
          <div className="flex">
            <div className="pl-4 md:pl-0 flex-shrink-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                <svg className="h-8 w-8" fill="white" viewBox="0 0 24 24">
                  <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                </svg>
              </div>
            </div>
            <div className="ml-4 mb-10 md:mb-0 pr-8 md:pr-0">
              <h5 className="text-lg leading-6 font-medium text-gray-900">
                Social Media & Content Marketing
              </h5>
              <p className="mt-2 text-base leading-6 text-gray-500">
                Social media is more than just a buzzword. We delve into effective strategies to
                make social work for you.
              </p>
            </div>
          </div>
        </li>
        <li className="list-none -mb-16">
          <div className="flex">
            <div className="pl-4 md:pl-0 flex-shrink-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-500 text-white">
                <svg className="h-8 w-8" fill="white" viewBox="0 0 24 24">
                  <path d="M24 23h-20c-2.208 0-4-1.792-4-4v-15.694c.313-1.071 1.285-2.306 3-2.306 1.855 0 2.769 1.342 2.995 2.312l.005 1.688h18v18zm-2-16h-16v11s-.587-1-1.922-1c-1.104 0-2.078.896-2.078 2s.896 2 2 2h18v-14zm-2 12h-12v-10h12v10zm-8-9h-3v8h10v-8h-6v3h6v1h-2v3h-1v-3h-3v3h-1v-7z" />
                </svg>
              </div>
            </div>
            <div className="ml-4 mb-10 md:mb-0 pr-8 md:pr-0">
              <h5 className="text-lg leading-6 font-medium text-gray-900">
                Web Design & Development
              </h5>
              <p className="mt-2 text-base leading-6 text-gray-500">
                We have in-house experts on deck ready to build out custom designs & functionality
                if and when you need it.
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
);

export default Services;
